import { PartyPopper } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ConfirmSuccess() {
    const { t } = useTranslation();
    return (
        <div className="flex items-start justify-center py-12">
            <div className="w-full max-w-lg rounded-2xl bg-white px-10 py-12 text-center shadow-sm">
                <div className="mx-auto mb-6 flex size-16 items-center justify-center rounded-full bg-primary/15">
                    <PartyPopper className="size-8 text-primary" />
                </div>
                <h1
                    data-testid="success-heading"
                    className="mb-3 text-2xl font-bold text-gray-900"
                >
                    {t("confirmStep.success.title")}
                </h1>
                <p className="mx-auto max-w-xs text-sm text-gray-500">
                    {t("confirmStep.success.subtitle")}
                </p>
            </div>
        </div>
    );
}
